export const MIN_WAIT_BEFORE_REFRESH_MS = 500;
export const INIT_RELOAD_BUFFER_MS = 3000;
export const RELOAD_FAVOURITES_DEBOUNCE_MS = 5000;
